import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { SelectItem } from 'src/app/modules/shared/components/custom-select/select-item';

@Component({
  selector: 'app-user-active-select',
  template: `
    <app-custom-select
      [data]="status"
      [selected]="selected"
      (selectedChange)="change($event)"
    ></app-custom-select>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserActiveSelectComponent implements OnChanges {
  @Input() active = true;
  @Output() activeChange = new EventEmitter<boolean>();

  selected?: SelectItem<boolean>;
  status: SelectItem<boolean>[] = [
    {
      label: 'Acesso Habilitado',
      value: true,
    },
    {
      label: 'Acesso Desabilitado',
      value: false,
    },
  ];

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.active) {
      this.selected = this.status.find(
        (select) => select.value === this.active
      );
    }
  }

  change(selectedItem: SelectItem<boolean>): void {
    this.active = selectedItem.value;
    this.selected = selectedItem;
    this.activeChange.emit(this.active);
  }
}
